// The web client of the XQ chat's meetings (Preact): it speaks the server's protocol
// (src/core/protocol.xq) in WebSocket messages, read and written by the schemas the server hands out. A
// meeting — a "пространство" — opens by its link, /m/<id>: its text and voice channels, who is in it, the
// chats, the sound and video of a voice channel (call.ts) and its transcripts, the host's buttons.
import { render } from "preact";
import { identity } from "./account.ts";
import { callStats } from "./call.ts";
import { accepted } from "./legal.ts";
import { leave, WEB_LINK } from "./meeting.ts";
import { connect, loadSchemas } from "./net.ts";
import { show, state, subscribe } from "./store.ts";
import { App } from "./ui/App.tsx";

async function main(): Promise<void> {
  // Drawn again from the top whenever the state changes, at once — not on an effect after a frame,
  // which a page out of sight may wait seconds for.
  const root = document.getElementById("app")!;
  const draw = () => render(<App />, root);
  subscribe(draw);
  draw();
  await identity();
  const m = location.pathname.match(WEB_LINK);
  state.wanted = m !== null ? m[1] : null;
  // A meeting's link opened by one without a name: the name is asked first (or none given, a guest); by one
  // who has not accepted the documents: they are, first.
  state.joining = state.wanted !== null && (state.name === "" || !accepted());
  try {
    await loadSchemas();
  } catch (err) {
    show(`сервер не отвечает: ${(err as Error).message}`, true);
    return;
  }
  show("соединяюсь…");
  connect();
}

addEventListener("popstate", () => {
  if (state.meeting !== null && !WEB_LINK.test(location.pathname)) leave();
});

// For tests: the state, and what the call sends and takes.
Object.assign(window, { xq: { state, callStats } });

void main();
